function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n                <div class=\"media-dialog__root ", "\">\n                    <div class=\"media-dialog__active\">\n                        <div class=\"swiper-container\">\n                            <div class=\"swiper-wrapper\">\n                                ", "\n                            </div>\n                        </div>\n\n                        <div class=\"media-dialog__prev\"></div>\n                        <div class=\"media-dialog__next\"></div>\n                    </div>\n\n                    <div class=\"swiper-container media-dialog__bottom\">\n                        <div class=\"swiper-wrapper\">\n                            ", "\n                        </div>\n                    </div>\n                </div>\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            ", "\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/* eslint-disable prefer-destructuring */

/* eslint-disable no-unused-expressions */
import { dataParam, reactive, register } from 'ovee.js';
import Swiper, { Lazy, Navigation, Thumbs } from 'swiper';
import WithSlots from '@/mixins/WithSlots';
import rem from '@/tools/rem';
import BaseDialog from './BaseDialog';
Swiper.use([Navigation, Thumbs, Lazy]);
var MediaDialog = (_dec = register('media-dialog'), _dec2 = dataParam('title'), _dec3 = reactive(), _dec4 = reactive(), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_WithSlots) {
  _inherits(MediaDialog, _WithSlots);

  var _super = _createSuper(MediaDialog);

  function MediaDialog() {
    var _this;

    _classCallCheck(this, MediaDialog);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "rootClass", 'media-dialog');

    _defineProperty(_assertThisInitialized(_this), "prevElement", void 0);

    _defineProperty(_assertThisInitialized(_this), "nextElement", void 0);

    _defineProperty(_assertThisInitialized(_this), "swiperContainer", void 0);

    _defineProperty(_assertThisInitialized(_this), "swiperThumbsContainer", void 0);

    _defineProperty(_assertThisInitialized(_this), "swiper", void 0);

    _defineProperty(_assertThisInitialized(_this), "swiper2", void 0);

    _defineProperty(_assertThisInitialized(_this), "count", 0);

    _defineProperty(_assertThisInitialized(_this), "closeTimeout", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "defaultTitle", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "customTitle", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "isMediaInitialized", _descriptor3, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(MediaDialog, [{
    key: "getSlides",
    value: function getSlides(slotName) {
      return this.slots[slotName].map(function (el) {
        var _el$classList;

        if ((_el$classList = el.classList) !== null && _el$classList !== void 0 && _el$classList.contains('media-dialog__item')) return el;
        return undefined;
      }).filter(function (el) {
        return el !== undefined;
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.swiper) this.swiper.destroy();
      if (this.swiper2) this.swiper2.destroy();
    }
  }, {
    key: "initSlides",
    value: function initSlides() {
      this.count = this.slides.length;
      [this.slides, this.thumbnails].forEach(function (slideTable) {
        slideTable.forEach(function (slide) {
          slide.classList.add('swiper-slide');
        });
      });
      this.swiperContainer = this.dialogTarget.querySelectorAll('.swiper-container')[0];
      this.swiperThumbsContainer = this.dialogTarget.querySelectorAll('.swiper-container')[1];
      this.prevElement = this.dialogTarget.querySelector('.media-dialog__prev');
      this.nextElement = this.dialogTarget.querySelector('.media-dialog__next');
    }
  }, {
    key: "initSwipers",
    value: function () {
      var _initSwipers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.swiper2 = new Swiper(this.swiperThumbsContainer, this.swiper2Options);
                this.swiper = new Swiper(this.swiperContainer, this.swiperOptions);
                this.swiper.on('slideChange', function (swiper) {
                  var img = swiper.slides[swiper.activeIndex].querySelector('img');
                  _this2.customTitle = img && img.dataset.title ? img.dataset.title : '';
                });
                this.swiper2.update();
                this.swiper.update();
                this.$emit('slider-initialized', this.swiper2);
                this.$emit('slider-initialized', this.swiper);
                this.initEvents();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initSwipers() {
        return _initSwipers.apply(this, arguments);
      }

      return initSwipers;
    }()
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this$prevElement,
          _this3 = this,
          _this$nextElement;

      (_this$prevElement = this.prevElement) === null || _this$prevElement === void 0 ? void 0 : _this$prevElement.addEventListener('click', function () {
        return _this3.onPrev();
      });
      (_this$nextElement = this.nextElement) === null || _this$nextElement === void 0 ? void 0 : _this$nextElement.addEventListener('click', function () {
        return _this3.onNext();
      });
      this.swiper2.slides.forEach(function (slide, index) {
        return slide.addEventListener('click', function () {
          if (index < _this3.swiper2.activeIndex) _this3.onPrev();else _this3.onNext();
        });
      });
    }
  }, {
    key: "onPrev",
    value: function onPrev() {
      var event = new Event('prev');
      this.dispatchEventOnSlides(this.swiper, event, false);
    }
  }, {
    key: "onNext",
    value: function onNext() {
      var event = new Event('next');
      this.dispatchEventOnSlides(this.swiper, event, false);
    }
  }, {
    key: "dispatchEventOnSlides",
    value: function dispatchEventOnSlides(slider, event, closeAll) {
      var _slider$slides;

      (_slider$slides = slider.slides) === null || _slider$slides === void 0 ? void 0 : _slider$slides.forEach(function (slide) {
        if (closeAll) {
          var _slide$querySelector;

          (_slide$querySelector = slide.querySelector('youtube-video-iframe')) === null || _slide$querySelector === void 0 ? void 0 : _slide$querySelector.dispatchEvent(event);
        } else if (!slide.classList.contains('swiper-slide-active')) {
          var _slide$querySelector2;

          (_slide$querySelector2 = slide.querySelector('youtube-video-iframe')) === null || _slide$querySelector2 === void 0 ? void 0 : _slide$querySelector2.dispatchEvent(event);
        }
      });
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(index) {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this4.$requestUpdate();

                        case 2:
                          _this4.initSlides();

                          _this4.initSwipers();

                          if (index) {
                            _this4.swiper.slideTo(index, 0, false);

                            _this4.swiper2.slideTo(index, 0, false);
                          }

                          _this4.isMediaInitialized = true;

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));
                _context3.next = 3;
                return _get(_getPrototypeOf(MediaDialog.prototype), "open", this).call(this);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function open(_x) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$swiper, _this$swiper2;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _get(_getPrototypeOf(MediaDialog.prototype), "close", this).call(this);

              case 2:
                this.dispatchEventOnSlides(this.swiper, new Event('prev'), true);
                (_this$swiper = this.swiper) === null || _this$swiper === void 0 ? void 0 : _this$swiper.destroy();
                (_this$swiper2 = this.swiper2) === null || _this$swiper2 === void 0 ? void 0 : _this$swiper2.destroy();
                this.isMediaInitialized = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "template",
    value: function template() {
      var _ref2;

      var title = (_ref2 = !this.customTitle || this.customTitle === '' ? this.defaultTitle : this.customTitle) !== null && _ref2 !== void 0 ? _ref2 : '';
      return this.html(_templateObject(), this.dialogWrapper(this.html(_templateObject2(), this.isMediaInitialized ? 'media-dialog__root--is-initialized' : '', this.slot(), this.slot('thumbnails')), title));
    }
  }, {
    key: "slides",
    get: function get() {
      return this.getSlides('default');
    }
  }, {
    key: "thumbnails",
    get: function get() {
      return this.getSlides('thumbnails');
    }
  }, {
    key: "swiperOptions",
    get: function get() {
      return {
        freeMode: false,
        allowTouchMove: true,
        spaceBetween: rem(10),
        speed: 800,
        thumbs: {
          swiper: this.swiper2
        },
        navigation: {
          nextEl: this.nextElement,
          prevEl: this.prevElement
        },
        breakpoints: {
          768: {
            spaceBetween: rem(20)
          }
        }
      };
    }
  }, {
    key: "swiper2Options",
    get: function get() {
      return {
        slidesPerView: 'auto',
        spaceBetween: rem(10),
        allowTouchMove: true,
        slideToClickedSlide: false,
        slidesOffsetBefore: rem(10),
        slidesOffsetAfter: rem(10),
        freeMode: false,
        centerInsufficientSlides: true,
        on: {
          click: function click(e) {
            e.slideTo(e.clickedIndex);
            e.activeIndex = e.clickedIndex;
          }
        }
      };
    }
  }]);

  return MediaDialog;
}(WithSlots(BaseDialog)), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "defaultTitle", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "customTitle", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "isMediaInitialized", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class);
export { MediaDialog as default };